import React, { useState, useEffect } from 'react';

function MusteriDuzenleModal({ musteri, isOpen, onClose, onSave }) {
    // Formdaki verileri tutmak için kendi state'i var
    const [formData, setFormData] = useState({});
    const [ilIlceListesi, setIlIlceListesi] = useState({ iller: [], ilceler: [] });

    // --- DÜZELTME: useEffect doğru yere, en üste taşındı ---
    // Düzenlenecek müşteri bilgisi değiştiğinde, form verisini güncelle
    useEffect(() => {
        // Sadece modal açıldığında ve düzenlenecek bir müşteri varsa formu doldur
        if (isOpen && musteri) {
            setFormData(musteri);
        } else {
            // Yeni müşteri ekleme modunda veya modal kapandığında formu temizle
            setFormData({});
        }
    }, [musteri, isOpen]); // Hem 'musteri' hem de 'isOpen' değiştiğinde çalışır

        useEffect(() => {
            if (isOpen) {
                fetch('/api/konum/iller')
                    .then(res => res.json())
                    .then(data => {
                        setIlIlceListesi(prev => ({ ...prev, iller: data }));
                    })
                    .catch(error => console.error('İller çekilirken hata:', error));
            }
        }, [isOpen]); // Modal her açıldığında illeri yeniden çeker
    
        // 2. Formdaki il seçimi değiştiğinde, o ile ait ilçeleri çeker
        useEffect(() => {
            const secilenIl = formData.il;
            if (secilenIl) {
                fetch(`/api/konum/ilceler/${secilenIl}`)
                    .then(res => res.json())
                    .then(data => {
                        setIlIlceListesi(prev => ({ ...prev, ilceler: data }));
                    })
                    .catch(error => console.error('İlçeler çekilirken hata:', error));
            } else {
                // Eğer il seçimi kaldırılırsa, ilçe listesini boşalt
                setIlIlceListesi(prev => ({ ...prev, ilceler: [] }));
            }
        }, [formData.il]); // Bu effect, sadece formdaki il değiştiğinde çalışır

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData); // Kaydetme işlemini ana bileşene bildir
    };

    // Eğer modal açık değilse, hiçbir şey gösterme
    if (!isOpen) {
        return null;
    }

    // --- Stil Tanımlamaları ---
    const modalOverlayStyle = { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 };
    const modalContentStyle = {background: '#F8F8F8', // Yeni zemin rengi
        padding: '30px',
        borderRadius: '8px',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)', // Yeni gölge
        border: '1px solid #C2C2C2', // Yeni çerçeve
        width: '400px',
        fontFamily: 'Poppins, sans-serif' // <-- YENİ: Ana font eklendi
        };
    const inputGroupStyle = {display: 'flex', flexDirection: 'column', gap: '30px', flex: 1 };
    const inputStyle = { padding: '8px 15px', border: '1px solid #ccc', borderRadius: '4px', fontFamily: 'inherit' };
    const labelStyle = { width: '200px', fontWeight: '500' };
    const fieldRowStyle = { display: 'flex', alignItems: 'center', gap: '10px' };

    return (
        <div style={modalOverlayStyle} onClick={onClose}>
            <div style={modalContentStyle} onClick={e => e.stopPropagation()}>
                <form onSubmit={handleSubmit}>
                    <h2 style={{ marginTop: 0 }}>Müşteri Bilgilerini Düzenle</h2>
                    <div style={inputGroupStyle}>
                        <div style={fieldRowStyle}>
                            <label style={labelStyle}>Adı Soyadı</label>
                            <input type="text" name="ad_soyad" value={formData.ad_soyad || ''} onChange={handleChange} style={inputStyle} />
                        </div>
                        <div style={fieldRowStyle}>
                            <label style={labelStyle}>Telefon Numarası</label>
                            <input type="text" name="telefon_numarasi" value={formData.telefon_numarasi || ''} onChange={handleChange} style={inputStyle} />
                        </div>
                        <div style={fieldRowStyle}>
                            <label style={labelStyle}>Adres</label>
                            <textarea name="adres" value={formData.adres || ''} onChange={handleChange} style={{...inputStyle, height: '80px',}} />
                        </div>
                        <div style={fieldRowStyle}>
                        <label style={labelStyle}>İl</label>
                        <select 
                            name="il" 
                            value={formData.il || ''} 
                            onChange={handleChange} 
                            style={inputStyle}
                        >
                            <option value="">İl Seçiniz</option>
                            {ilIlceListesi.iller.map(il => (
                                <option key={il} value={il}>{il}</option>
                            ))}
                        </select>
                        </div>
                        <div style={fieldRowStyle}>
                            <label style={labelStyle}>İlçe</label>
                            <select 
                                name="ilce" 
                                value={formData.ilce || ''} 
                                onChange={handleChange} 
                                disabled={!formData.il} // İl seçilmediyse ilçe pasif olsun
                                style={inputStyle}
                            >
                                <option value="">İlçe Seçiniz</option>
                                {ilIlceListesi.ilceler.map(ilce => (
                                    <option key={ilce} value={ilce}>{ilce}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px', borderTop: '1px solid #eee', paddingTop: '20px' }}>
                        <button type="button" onClick={onClose} style={{
                            width: '110px',
                            height: '37px',
                            background: '#F8F8F8',
                            borderRadius: '8px',
                            border: '0.50px black solid',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500'
                        }}>Vazgeç</button>
                        <button type="submit" style={{
                            width: '110px',
                            height: '37px',
                            background: '#F8F8F8', // Şimdilik ikisi de aynı stilde
                            borderRadius: '8px',
                            border: '0.50px black solid',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500'
                        }}>Tamam</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default MusteriDuzenleModal;